import React, {Component} from "react";

export class OrderRequestDetails extends Component {
    render(){
        return(
            <>
            <div className="manage-order-container">
                <div className="order-modal-list-form-container">
                      <h1>Order Request Details</h1>
                      <div className="order-details-container">
                        <h2>Order Number</h2>
                        <span>TEMQR20221083</span>
                      </div>                      
                </div>               
            </div>    
            <div className="manage-order-container">
                 <div className="order-modal-list-form-container">
                      <h1>Subscription</h1>
                      <div className="order-details-container">
                        <div className="order-information-header-container">
                                <h2>Vendor</h2>
                                <h2>Circuit Type</h2>
                                <h2>Contract Terms</h2>                                
                        </div>
                        <div className="order-information-details-container">
                                <span>SFR (FR)</span>
                                <span>P2P</span>
                                <span>12</span>                               
                        </div>
                        <div className="order-information-header-container">
                                <h2>Bandwidth</h2>
                        </div>
                        <div className="order-information-details-container">
                                <span>50 MBPS</span>
                        </div>
                      </div>
                </div>
            </div>  
            <div className="manage-order-container">
                 <div className="order-modal-list-form-container">
                      <h1>Location Information</h1>
                      <div className="order-details-container">
                        <div className="order-information-header-container">
                                <h2>Country</h2>
                                <h2>Address</h2>
                                <h2>Address 2 (P2P)</h2>                                
                        </div>
                        <div className="order-information-details-container">
                                <span>France</span>
                                <span>Lorem Ipsum dolor sit amet</span>
                                <span>Lorem Ipsum dolor sit amet</span>                               
                        </div>
                      </div>
                </div>
            </div>     
            <div className="manage-order-container">
                 <div className="order-modal-list-form-container">
                      <h1>Business Justification</h1>
                      <div className="order-details-container">
                        <div className="order-information-header-container">
                                <h2>Purpose of Use</h2>
                                <h2>Business Justification</h2>
                                <h2>Additional Information</h2>                                
                        </div>
                        <div className="order-information-details-container">
                                <span>Special Use Subscription</span>
                                <span>Lorem Ipsum dolor sit amet</span>
                                <span>Lorem Ipsum dolor sit amet</span>                               
                        </div>
                      </div>
                </div>
            </div>              
            </>
        );
    }
}